import axios from "axios";
import * as Sentry from "@sentry/vue";
import { App } from "vue";
import { Router } from "vue-router";

export const beforeSend = (event: any, hint: any) => {
  // NOTE: we don't want to log cancelled requests, to cancel request is normal behavior and occurs i.e. in search if a new search is started but previous requests are still running

  if (axios.isCancel(hint.originalException)) {
    return null;
  }
  // Catch 401 errors and don't log them, as they are expected if the refresh token is invalid
  if (event.exception && event.exception.values) {
    const exception = event.exception.values[0];
    if (exception.dontLog) {
      return null;
    }
    if (
      exception.type === "AxiosError" &&
      exception.value &&
      exception.value.includes("Request failed with status code 401")
    ) {
      return null;
    }
  }
  // Catch imported module errors and don't log them, as they are expected with updated vertsions and are handled in the router
  if (
    event.exception?.values?.some(
      (ex: any) =>
        ex.value?.includes("Failed to fetch dynamically imported module") ||
        ex.value?.includes("Importing a module script failed") ||
        ex.value?.includes("error loading dynamically imported module"),
    )
  ) {
    return null;
  }
  return event;
};

export function sentryInit(
  app: App,
  router: Router,
): Parameters<typeof Sentry.init>[0] {
  return {
    app,
    dsn: "https://57d15d7b915a763f7baeb42c6bbd269d@o394164.ingest.us.sentry.io/4508539961999360",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    beforeSend: beforeSend,

    ignoreErrors: [
      // old hashed CSS/JS chunks no longer exist after a new deploy.
      "Unable to preload CSS for",
    ],
  };
}
